<template>
  <tr data-test="examination-media-row">
    <td>
      <button class="btn btn-sm btn-outline-secondary" @click="$emit('toggle')">
        <span v-if="expanded">−</span>
        <span v-else>+</span>
      </button>
    </td>
    <td class="text-muted">{{ index + 1 }}</td>
    <td>{{ medium.label || "—" }}</td>
    <td class="font-monospace">
      <div
        class="text-truncate"
        style="max-width: 520px"
        :title="displayFilename(medium)"
      >
        {{ displayFilename(medium) }}
      </div>
      <div class="small text-muted">ID: {{ medium.attachment_id }}</div>
    </td>
    <td class="font-monospace">{{ medium.mime_type || "—" }}</td>
    <td class="font-monospace">{{ medium.size }}</td>
    <td>
      <span :class="badgeClass(medium.status)">{{ medium.status }}</span>
    </td>
    <td>
      <div class="d-flex align-items-center">
        <div class="progress me-2" style="width: 240px; height: 8px">
          <div
            class="progress-bar"
            role="progressbar"
            :style="{ width: (medium.progress?.percent || 0) + '%' }"
            :aria-valuenow="medium.progress?.percent || 0"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <span class="text-muted"
          >&nbsp;{{ medium.progress?.completed || 0 }}/{{
            medium.progress?.total || 0
          }}
          ({{ medium.progress?.percent || 0 }}%)</span
        >
      </div>
    </td>
    <td>{{ medium.latest_part_uploaded_at || "—" }}</td>
    <td>{{ medium.completed_at || "—" }}</td>
  </tr>
</template>

<script>
import { badgeClass, prettyType, displayFilename } from "./utils/helpers";

export default {
  name: "ExaminationMediaRow",
  props: {
    medium: { type: Object, required: true },
    index: { type: Number, required: true },
    expanded: { type: Boolean, default: false },
  },
  methods: { badgeClass, prettyType, displayFilename },
};
</script>
